<template>
  <v-dialog
    v-bind="$attrs"
    max-width="500"
    persistent
  >
    <v-card>
      <v-card-title
        class="title pt-5 pb-0"
        primary-title
      >
        Vencimento próximo
      </v-card-title>

      <v-card-text
        class="pt-3"
      >
        <p>
          A data de vencimento está bem próxima.
          Você possui disponibilidade para pagar o boleto até o dia
          {{ dataVencimento | dataFormatada(null, '2-digit', '2-digit') }}?
        </p>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          text
          data-cy="btn_nao_trocar_boleto"
          @click="emitirEvento('nao')"
        >
          Não
        </v-btn>
        <v-btn
          color="primary"
          text
          data-cy="btn_sim_trocar_boleto"
          @click="emitirEvento('sim')"
        >
          Sim
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'ModalTrocaPagamentoBoleto',

  props: {
    dataVencimento: {
      type: String,
      required: true,
    },
  },

  methods: {
    emitirEvento(resposta) {
      this.$emit('resposta');
      this.$emit(`resposta-${resposta}`);
    },
  },
};
</script>
